import { render, staticRenderFns } from "./AdicionalModal.vue?vue&type=template&id=efbc962c&scoped=true"
import script from "./AdicionalModal.vue?vue&type=script&lang=js"
export * from "./AdicionalModal.vue?vue&type=script&lang=js"
import style0 from "./AdicionalModal.vue?vue&type=style&index=0&id=efbc962c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbc962c",
  null
  
)

export default component.exports